import script from "./AuthForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthForm.vue?vue&type=script&setup=true&lang=ts"

import "./AuthForm.vue?vue&type=style&index=0&id=6ae4af8c&lang=scss"

const __exports__ = script;

export default __exports__